"use strict";

var ACCESSORIES_THANK_YOU_CARDS = 'Accessories Thank You Cards';
var COMPONENTS_CARDS = 'Components Cards';
var DOUBLE_THICK_EXAMPLE_CARDS = 'Double Thick Example Cards';
var ENVELOPE_LINER_INSERTS = 'Envelope Liner Inserts';
var INFORMATION_2018_CARDS = 'Information 2018 Cards';
var INVITATION_THANK_YOU_CARDS = 'Invitation Thank You Cards';
var LETTERPRESS_SAMPLE_CARDS = 'Letterpress Sample Cards';
var ORDER_TIMELINE_CARDS = 'Order Timeline Cards';
var PACKED_BY_CARDS = 'Packed By Cards';
var PHOTOGRAPHY_INSERTS = 'Photography Inserts';
var RIBBON_INSTRUCTIONS = 'Ribbon Instructions';
var RIBBON_SAMPLE_INSTRUCTIONS = 'Ribbon Sample Instructions';
var SAVE_THE_DATE_THANK_YOU_CARDS = 'Save The Date Thank You Cards';
var STANDARD_INSTRUCTIONS = 'Standard Instructions';
var WHY_SHINE_CARDS = 'Why Shine Cards';
var CUSTOM_COLOR_CHARTS = 'Custom Color Charts';
var COLOR_CHART_LINERS = 'Color Chart Liners';
var COLOR_CHART_KITS = 'Color Chart Kits';
var COLOR_CHARTS = 'Color Charts';
var SAMPLE_CLASSIC_INVITATION_SUITES = 'Sample Classic Invitation Suites';
var RIBBON_SAMPLE_CARDS = 'Ribbon Sample Cards';
var LINER_SAMPLES = 'Liner Samples';
module.exports = {
  LINER_SAMPLES: LINER_SAMPLES,
  RIBBON_SAMPLE_CARDS: RIBBON_SAMPLE_CARDS,
  SAMPLE_CLASSIC_INVITATION_SUITES: SAMPLE_CLASSIC_INVITATION_SUITES,
  COLOR_CHARTS: COLOR_CHARTS,
  COLOR_CHART_KITS: COLOR_CHART_KITS,
  COLOR_CHART_LINERS: COLOR_CHART_LINERS,
  CUSTOM_COLOR_CHARTS: CUSTOM_COLOR_CHARTS,
  ACCESSORIES_THANK_YOU_CARDS: ACCESSORIES_THANK_YOU_CARDS,
  COMPONENTS_CARDS: COMPONENTS_CARDS,
  DOUBLE_THICK_EXAMPLE_CARDS: DOUBLE_THICK_EXAMPLE_CARDS,
  ENVELOPE_LINER_INSERTS: ENVELOPE_LINER_INSERTS,
  INFORMATION_2018_CARDS: INFORMATION_2018_CARDS,
  INVITATION_THANK_YOU_CARDS: INVITATION_THANK_YOU_CARDS,
  LETTERPRESS_SAMPLE_CARDS: LETTERPRESS_SAMPLE_CARDS,
  ORDER_TIMELINE_CARDS: ORDER_TIMELINE_CARDS,
  PACKED_BY_CARDS: PACKED_BY_CARDS,
  PHOTOGRAPHY_INSERTS: PHOTOGRAPHY_INSERTS,
  RIBBON_INSTRUCTIONS: RIBBON_INSTRUCTIONS,
  RIBBON_SAMPLE_INSTRUCTIONS: RIBBON_SAMPLE_INSTRUCTIONS,
  SAVE_THE_DATE_THANK_YOU_CARDS: SAVE_THE_DATE_THANK_YOU_CARDS,
  STANDARD_INSTRUCTIONS: STANDARD_INSTRUCTIONS,
  WHY_SHINE_CARDS: WHY_SHINE_CARDS
};